import { AfterViewInit, Component, ElementRef, Input, OnInit, QueryList, Renderer2, ViewChild, ViewChildren } from "@angular/core";
import { MenuItem } from "../../../objects/components/menuItem";
import { Guid } from "../../../common/helpers/guidHelper";
import { SideBarComponent } from "../sideBar/sideBar.component";
import { Router, GuardsCheckEnd } from "@angular/router";
import Timer = NodeJS.Timer;

@Component({
    selector: 'side-menu',
    templateUrl: './sideMenu.component.html',
    styleUrls: ['../../../../theme/css/sideMenu.css'],
    moduleId: module.id.toString()
})
export class SideMenuComponent implements OnInit, AfterViewInit {
    constructor(private renderer: Renderer2, private router: Router) {
    }

    private sidebarTimer: Timer;
    private initialized: boolean = false;
    private activeMenu: HTMLElement;

    public stringHelper = String;

    @Input() sideBar: SideBarComponent;
    @Input() menuItems: Array<MenuItem>;
    @Input() collapsedMenuPrefix: string;

    @ViewChildren("menuLi") menuLiRef: QueryList<ElementRef>;
    @ViewChildren("menuItem") menuRef: QueryList<ElementRef>;
    @ViewChildren("menuItemDiv") menuDivRef: QueryList<ElementRef>;
    @ViewChildren("menuChild") menuChildRef: QueryList<ElementRef>;
    @ViewChild("movingTab") movingTab: ElementRef;

    ngOnInit(): void {
        if (String.isNullOrEmpty(this.collapsedMenuPrefix)) {
            this.collapsedMenuPrefix = Guid.newGuid();
        }
    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            let stop = false;

            const menuRef = this.menuRef.toArray();
            const menuDivRef = this.menuDivRef.toArray();
            const menuChildRef = this.menuChildRef.toArray();
            let menuIndex = 0;

            this.menuItems.forEach((menu, index) => {
                if(menuRef.length > index)
                    menu.Element = menuRef[index];
                else
                    menu.Element = menuDivRef[index];

                const div = menuDivRef[index];

                if (!menu.Collapsed) {
                    this.setHeight(div.nativeElement, div.nativeElement.scrollHeight);
                }

                if(menu.Children == null || menu.Children.length == 0)
                    return true;

                menu.Children.forEach((item, childIndex) => {
                    item.Element = menuChildRef[menuIndex + childIndex];

                    if(!stop) {
                        if (this.router.isActive(item.Path, item.Exact)) {
                            menu.Collapsed = false;
                            this.setMovingTabPosition(null);
                            stop = true;
                            return false;
                        }
                    }
                });

                menuIndex += menu.Children.length;
            });

            this.initAnimation();
        }, 20);
    }

    onCollapsed(event: any) {
        this.setHeight(event._el.nativeElement, 0);
        setTimeout(() => {
            this.setMovingTabPosition(null)
        }, 500)
    }

    onExpanded(event: any) {
        this.setHeight(event._el.nativeElement, 0);
        this.setHeight(event._el.nativeElement, event._el.nativeElement.scrollHeight);
        setTimeout(() => {
            this.setMovingTabPosition(null)
        }, 500)
    }

    setHeight(el: HTMLElement, height: number) {
        this.renderer.setStyle(el, 'height', height + 'px');
    }

    public initAnimation(): void {
        setTimeout(() => {
            const activeMenu = this.findActiveMenu(this.router.url);

            if (activeMenu == null || activeMenu.Element == null)
                return;

            this.activeMenu = activeMenu.Element.nativeElement;
            this.initialized = true;

            this.renderer.addClass(activeMenu.Element.nativeElement.parentElement, "visible");

            this.router.events.subscribe((val) => {
                if (!(val instanceof GuardsCheckEnd))
                    return;

                if(!val.shouldActivate)
                    return;

                const activeMenu = this.findActiveMenu(val.url);

                if (activeMenu == null || activeMenu.Element == null)
                    return;

                const parent = this.findParentMenu(val.url);
                this.activeMenu = activeMenu.Element.nativeElement;

                if(parent != null) {
                    parent.Collapsed = false;

                    setTimeout(() => {
                        this.animateMovingTab();
                    }, 100);
                } else {
                    this.animateMovingTab();
                }
            });
        });
    }

    private animateMovingTab(): void {
        clearTimeout(this.sidebarTimer);

        for(const li of this.menuLiRef.toArray()) {
            this.renderer.removeClass(li.nativeElement, 'visible');
            this.renderer.removeClass(li.nativeElement, 'active');
        }

        for(const child of this.menuChildRef.toArray())
            this.renderer.removeClass(child.nativeElement.parentElement, 'active');

        this.movingTab.nativeElement.style.paddingLeft = window.getComputedStyle(this.activeMenu).paddingLeft;
        this.renderer.addClass(this.movingTab.nativeElement, 'moving');

        let button_text = this.activeMenu.innerHTML;

        this.setMovingTabPosition(this.activeMenu);

        this.sidebarTimer = setTimeout(() => {
            this.renderer.removeClass(this.movingTab.nativeElement, 'moving');
            this.renderer.addClass(this.activeMenu.parentElement, 'visible');
            this.renderer.addClass(this.activeMenu.parentElement, 'active');

            const parent = this.findParentMenu(this.router.url);
            if(parent != null) {
                this.renderer.addClass(parent.Element.nativeElement.parentElement, 'active');
            }
        }, 650);

        setTimeout(() => {
            this.movingTab.nativeElement.innerHTML = button_text;
        }, 10);
    }

    private setMovingTabPosition(currentActive: HTMLElement): void {
        if (!this.initialized)
            return;

        currentActive = currentActive || this.activeMenu;

        let li_distance = currentActive.parentElement.offsetTop - 10;

        let collapse = currentActive.closest('.collapse');
        if (collapse != null) {
            let parent_distance = collapse.parentElement.offsetTop;
            if (collapse.className.indexOf('in') != -1)
                li_distance = li_distance + parent_distance;
            else
                li_distance = parent_distance;
        }

        this.movingTab.nativeElement.style.transform = 'translate3d(0px,' + li_distance + 'px, 0)';
    }

    private findActiveMenu(url: string): MenuItem {
        let activeMenu: MenuItem;
        for (const menu of this.menuItems) {
            if (menu.Path == url) {
                activeMenu = menu;
                break;
            }

            if (menu.Children == null || menu.Children.length == 0)
                continue;

            for (const child of menu.Children) {
                if (child.Path == url || (!child.Exact && url.startsWith(child.Path))) {
                    activeMenu = child;
                    break;
                }
            }
        }
        return activeMenu;
    }

    private findParentMenu(url: string): MenuItem {
        let activeMenu: MenuItem;
        for (const menu of this.menuItems) {
            if (menu.Children == null || menu.Children.length == 0)
                continue;

            for (const child of menu.Children) {
                if (child.Path == url || (!child.Exact && url.startsWith(child.Path))) {
                    activeMenu = menu;
                    break;
                }
            }
        }
        return activeMenu;
    }
}


// WEBPACK FOOTER //
// ./app/components/sidebar/sideMenu/sideMenu.component.ts